export const UPDATEUSER = 'UPDATEUSER';

export type User = {
  userId?: string | null;
  email?: string | null;
  isAuthenticated?: boolean;
};
